<template>
  <div id="mapdiv"></div>
</template>

<script>
/* global L */
import mapboxgl from "mapbox-gl";
import { mapGetters } from "vuex";
import LogoControl from "./Map/logo_control";
import LayerManager from "./Map/layer_manager";

mapboxgl.accessToken = "pk.eyJ1IjoiY2FtZXJvbnByZWJibGUiLCJhIjoiWGhROVZ2VSJ9.qH4CfsA9rJ-4IrofeaSLMw";

export default {
  computed: {
    ...mapGetters({
      boundingBox: "currentBounds",
      markers: "currentMarkers",
      layerUrl: "currentLayerUrl",
      highlightedFeature: "currentHighlightedFeature"
    })
  },
  mounted() {
    let hoverArea,
        logoControl;

    this.map = new mapboxgl.Map({
      container: this.$el,
      style: "mapbox://styles/mapbox/light-v9",
      center: [174.777222, -41.288889],
      zoom: 3
    });

    this.layerManager = new LayerManager(this.map);

    logoControl = new LogoControl()
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.addControl(logoControl);

    this.map.on('load', () => {
      document.addEventListener("fullscreenchange", (e) => {
        let logoVisible = document.fullscreenElement !== null;
        logoControl.toggle(logoVisible);
      });
    });
  },
  watch: {
    boundingBox(newBounds) {
      this.map.fitBounds(newBounds, {
        duration: 500,
        padding: { top: 5, bottom: 5, left: 5, right: 5 }
      });
    },
    markers(newMarkers, oldMarkers) {
      oldMarkers.forEach(marker => marker.remove());
      newMarkers.forEach(marker => marker.addTo(this.map));
    },
    layerUrl(newLayerUrl) {
      this.layerManager.updateTileset(newLayerUrl);
    },
    highlightedFeature(featureId) {
      this.layerManager.highlightFeature(featureId);
    }
  }
};
</script>

<style lang="scss">
  @import "../assets/mixins";

  #mapdiv {
    height: 150px;

    @include media-breakpoint-up(sm) {
      height: 200px;
    }

    @include media-breakpoint-up(md) {
      height: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue